import React from "react";
import ServicePageLayout from "./ServicePageLayout";

const SMSMarketingServices = () => {
  return (
    <ServicePageLayout
      imageTitle={
        [
          "AI-Integrated Staffing Solutions for Smarter, Faster Hiring "
        ]
      }
      heroImage="/sms-service.png"
      sectionTitle="Our Services"
      description={[
        "Whether you’re a startup, SME, or enterprise, we provide tailored SMS solutions that suit your marketing goals: ",
      ]}
      benefitsTitle=""
      benefits={[
        "📢 Promotional SMS",
        "📬 Transactional SMS",
        "🎯 Bulk SMS Campaigns",
        "🛍 SMS for E-commerce",
        "🏥 SMS for Healthcare",
        "🎓 SMS for Educational Institutions",
        "📊 Real-Time Analytics & Reporting",
        "🔒 DND Filter & Secure API Integration",
      ]}
      secondaryImage="/sms-service-section.png"
      servicesTitle="Why Choose Glow Tech Solutions for SMS Marketing?"
      services={[
        {
          title: " Instant Delivery",
          desc: "Messages are delivered within seconds across all major telecom operators. ",
        },
        {
          title: "Proven Results",
          desc: "Our clients see higher engagement, improved sales, and greater ROI through strategic SMS marketing. ",
        },
        {
          title: "Wide Reach",
          desc: "Connect with thousands of users across India, no matter the region or telecom provider. ",
        },
        {
          title: "User-Friendly Dashboard",
          desc: "Easily schedule, customize, and monitor campaigns with our intuitive SMS panel. ",
        },
        {
          title: "Targeted Campaigns",
          desc: "Send segmented messages based on behavior, geography, or custom demographics. ",
        },
        {
          title: "Keyword Research & Analysis",
          desc: "We find the most relevant, high-converting keywords tailored to your business goals and audience intent.",
        },
        {
          title: "Cost-Effective Plans",
          desc: "Affordable bulk SMS pricing with no hidden charges",
        },
      ]}
    />
  );
};

export default SMSMarketingServices;
